import { createFileRoute } from '@tanstack/react-router';
import { TicketingPage } from '../../features/ticketing/TicketingPage.jsx';

export const Route = createFileRoute('/_app/ticketing/')({ component: () => <TicketingPage eventId={null} /> });
